import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue';

export const useBannerVisibility = (
	rootElement: Ref<HTMLElement | null>,
	hasVisibleContent: (element: HTMLElement) => boolean,
): { shouldHide: Ref<boolean>; syncVisibility: () => void } => {
	const shouldHide = ref(true);

	let observer: MutationObserver | undefined;

	const syncVisibility = (): void => {
		const element = rootElement.value;
		if (!element) return;

		shouldHide.value = !hasVisibleContent(element);
	};

	onMounted(() => {
		if (typeof window === 'undefined') return;

		syncVisibility();

		observer = new MutationObserver(() => {
			syncVisibility();
		});

		observer.observe(rootElement.value!, {
			childList: true,
			subtree: true,
		});
	});

	onBeforeUnmount(() => {
		observer?.disconnect();
	});

	return {
		shouldHide,
		syncVisibility,
	};
};
